import React from "react";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ListGroup from "react-bootstrap/ListGroup";

import MarkdownTester from "./shared/MarkdownTester";

import markdown_header from "./CampboardMarkdownHeader.png";

export default function MarkdownCheatsheetPage() {
  return (
    <Row className="p-5 cheatsheet-markdown justify-content-center">
      <Col style={{ maxWidth: 1000 }}>
        <img
          className="mb-4"
          src={markdown_header}
          alt=""
          style={{ width: "100%", maxWidth: "500px" }}
        />

        <h2>Markdown Cheatsheet</h2>
        <AncoredTitle>Was genau ist Markdown?</AncoredTitle>
        <p>
          Markdown ist eine vereinfachte Auszeichnungssprache. Ziel von Markdown
          ist, mit blossem Text einen Artikel oder Text zu formatieren. Markdown
          verfügt über verschiedene Elemente, die mit dem richtigen Syntax
          verwendet werden können. Markdown wird in Entwicklungstools wie
          GitHub, GitLab, Trello aber auch Campboard verwendet. Jedoch
          unterscheidet sich der Syntax oft von Plattform zu Plattform - der
          Syntax von Campboard kann also nur begrenz in Github oder Gitlab
          verwendet werden. Dieses Cheatsheet beinhält interaktive Beispiele,
          welche du zum Lernen des Markdown Syntax benutzen kannst.
        </p>
        <AncoredTitle>Markdown Komponenten</AncoredTitle>
        <AncoredTitle subtitle>Headers</AncoredTitle>
        <p>
          Markdown kann Text ganz normal darstellen. Es können aber auch
          Überschriften in verschiedenen Grössen erstellt werden.
        </p>
        <MarkdownTester
          content={`# H1
## H2
### H3
#### H4
##### H5
###### H6`}
        />

        <AncoredTitle subtitle>Text formatieren</AncoredTitle>
        <p>
          Markdown kann Text formatieren. Du kannst Text <b>fett</b>,{" "}
          <i>schräggestellt</i> und <u>unterschtrichen</u> schreiben. Du kannst
          auch{" "}
          <b>
            <u>kombinieren</u>
          </b>
          .
        </p>
        <MarkdownTester
          content={`**At vero eos et** accusamus et *iusto* odio dignissimos ducimus qui ***blanditiis praesentium*** voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, ~similique~ sunt in culpa qui officia ~*deserunt mollitia animi*~, id est laborum et ~**dolorum fuga. Et harum quidem**~ rerum facilis est et expedita distinctio.`}
        />

        <AncoredTitle subtitle>Lists</AncoredTitle>
        <p>
          Markdown kann Listen erstellen. Dazu können verschiedene Zeichen vor
          den Listenelementen verwendet werden, um nummerierte oder
          unnummerierte Listen zu erstellen.
        </p>
        <MarkdownTester
          content={`1. Erstes Element
2. Zweites Element
3. Drittes Element
- Ungeordnetes Element
- Ungeordnetes Element
- Ungeordnetes Element
+ Ungeordnetes Element
* Ungeordnetes Element`}
        />

        <AncoredTitle subtitle>HTML verwenden</AncoredTitle>
        <p>
          Im Markdown können aus einer ausgewählten Kollektion Elemente
          ausgewählt werden.
        </p>
        <MarkdownTester
          content={`Wow this is <b>pretty cool</b>. You can use most tags, you can even use classes: <button class="btn btn-primary">Click me</button>.<br/><br/>You can also use Markdown inside HTML:<br/>
                <div class="border border-primary">
                    *Wow cool*
                </div>`}
        />

        <AncoredTitle subtitle>Links</AncoredTitle>
        <p>
          Markdown kann Links erstellen. Dazu kann der Link direkt eingefügt
          werden, oder der angezeigte Inhalt kann mit verschiedenen Syntax
          Variationen angepasst werden.
        </p>
        <MarkdownTester
          content={`[I'm an inline-style link](https://www.google.com)

[I'm an inline-style link with title](https://www.google.com "Google's Homepage")

[I'm a reference-style link][Arbitrary case-insensitive reference text]

[I'm a relative reference to a repository file](../blob/master/LICENSE)

[You can use numbers for reference-style link definitions][1]

Or leave it empty and use the [link text itself].

URLs and URLs in angle brackets will automatically get turned into links. 
http://www.example.com or <http://www.example.com> and sometimes 
example.com (but not on Github, for example).

Some text to show that the reference links can follow later.

[arbitrary case-insensitive reference text]: https://www.mozilla.org
[1]: http://slashdot.org
[link text itself]: http://www.reddit.com`}
        />

        <AncoredTitle subtitle>Images</AncoredTitle>
        <p>
          Markdown kann auch Bilder anzeigen. Dazu muss die URL mit einer
          validen Endung enden.
        </p>
        <MarkdownTester
          content={`Inline-style: 
![alt text](https://github.com/adam-p/markdown-here/raw/master/src/common/images/icon48.png "Logo Title Text 1")

Reference-style: 
![alt text][logo]

[logo]: https://github.com/adam-p/markdown-here/raw/master/src/common/images/icon48.png "Logo Title Text 2"`}
        />

        <AncoredTitle subtitle>Code</AncoredTitle>
        <p>
          Markdown kann auch Code darstellen. Verschiedene Sprachen können zudem
          gefärbt werden.
        </p>
        <MarkdownTester
          content={`Inline \`code\` has \`back-ticks around\` it.
\`\`\`javascript
var s = "JavaScript syntax highlighting";
alert(s);
\`\`\`
 
\`\`\`python
s = "Python syntax highlighting"
print s
\`\`\`
 
\`\`\`
No language indicated, so no syntax highlighting. 
But let's throw in a <b>tag</b>.
\`\`\``}
        />

        <AncoredTitle subtitle>Tables</AncoredTitle>
        <p>
          Es können auch Tabellen erstellt werden. Spalten können zudem
          formatiert werden.
        </p>
        <MarkdownTester
          content={`Colons can be used to align columns.

| Tables        | Are           | Cool  |
| ------------- |:-------------:| -----:|
| col 3 is      | right-aligned | \$1600 |
| col 2 is      | centered      |   \$12 |
| zebra stripes | are neat      |    \$1 |

There must be at least 3 dashes separating each header cell.
The outer pipes (|) are optional, and you don't need to make the 
raw Markdown line up prettily. You can also use inline Markdown.

Markdown | Less | Pretty
--- | --- | ---
*Still* | \`renders\` | **nicely**
1 | 2 | 3`}
        />

        <AncoredTitle subtitle>Blockquotes</AncoredTitle>
        <p>Markdown kann auch Zitate oder Textabschnitte hervorheben.</p>
        <MarkdownTester
          content={`> Blockquotes are very handy in email to emulate reply text.
> This line is part of the same quote.

Quote break.

> This is a very long line that will still be quoted properly when it wraps. Oh boy let's keep writing to make sure this is long enough to actually wrap for everyone. Oh, you can *put* **Markdown** into a blockquote. `}
        />

        <AncoredTitle subtitle>Youtube</AncoredTitle>
        <p>
          Youtube kann auch eingebunden werden. Es funktionieren alle normalen
          und bekannten Link Formate.
        </p>
        <MarkdownTester
          content={`http://www.youtube.com/watch?v=4KHiSt0oLJ0

Hier ein anderer Link:

https://youtube.com/watch?v=Mvu5OMGcdVA

Links werden inline nicht angezeigt: https://www.youtube.com/watch?v=Mvu5OMGcdVA`}
        />

        <AncoredTitle subtitle>Emojis</AncoredTitle>
        <p>
          Das Flavored Markdown von Campboard kann auch Emojis anzeigen! Hier
          eine Liste von Emojis:{" "}
          <a
            href="https://www.webfx.com/tools/emoji-cheat-sheet/"
            target="_blank"
            rel="noreferrer"
          >
            www.webfx.com cheat-sheet
          </a>
        </p>
        <MarkdownTester content={`:joy: :smile: :cry:`} />

        <AncoredTitle subtitle>Hinweise</AncoredTitle>
        <MarkdownTester
          content={`!> Here is a tip.

?> And a warning.

x> Or an error.`}
        />

        <AncoredTitle subtitle></AncoredTitle>
        <p>
          Campboard unterstützt{" "}
          <a target="_blank" rel="noreferrer" href="https://katex.org">
            katex
          </a>{" "}
          um mathematische Ausdrücke anzuzeigen
        </p>
        <MarkdownTester
          content={`Campboard's markdown will render a mathematic expression with \`\`$$ expression $$\`\`

$$
\\f\\relax{x} = \\int_{-\\infty}^\\infty
    \\f\\hat\\xi\\,e^{2 \\pi i \\xi x}
    \\,d\\xi
$$

Lift($L$) can be determined by Lift Coefficient ($C_L$) like the following
equation.

$$
L = \\frac{1}{2} \\rho v^2 S C_L
$$

Have a look here to [see all supported katex expressions](https://katex.org/docs/supported.html)

**Here have some random expressions from hell**:
$$
\\begin{aligned}
\\nabla \\times \\vec{\\mathbf{B}} -\\, \\frac1c\\, \\frac{\\partial\\vec{\\mathbf{E}}}{\\partial t} & = \\frac{4\\pi}{c}\\vec{\\mathbf{j}} \\\\   
\\nabla \\cdot \\vec{\\mathbf{E}} & = 4 \\pi \\rho \\\\
\\nabla \\times \\vec{\\mathbf{E}}\\, +\\, \\frac1c\\, \\frac{\\partial\\vec{\\mathbf{B}}}{\\partial t} & = \\vec{\\mathbf{0}} \\\\
\\nabla \\cdot \\vec{\\mathbf{B}} & = 0 \\end{aligned}
$$

$$
\\mathcal L_{\\mathcal T}(\\vec{\\lambda})
    = \\sum_{(\\mathbf{x},\\mathbf{s})\\in \\mathcal T}
    \\log P(\\mathbf{s}\\mid\\mathbf{x}) - \\sum_{i=1}^m
    \\frac{\\lambda_i^2}{2\\sigma^2}
$$

$$
\\frac{1}{\\Bigl(\\sqrt{\\phi \\sqrt{5}}-\\phi\\Bigr) e^{\\frac25 \\pi}} \\equiv 1+\\frac{e^{-2\\pi}} {1+\\frac{e^{-4\\pi}} {1+\\frac{e^{-6\\pi}} {1+\\frac{e^{-8\\pi}} {1+\\cdots} } } }
$$

Have a look at this expression:
$$
x^2 + y^2 = z^2
$$`}
        />

        <AncoredTitle subtitle>Inhaltsverzeichnisse</AncoredTitle>
        <p>
          Das Flavored Markdown von Campboard kann auch automatisch
          Inhaltsverzeichnisse erstellen. Dafür wird nach "# Table of contents"
          oder "# toc" gesucht.{" "}
          <b>
            Achtung: Funktioniert unzuverlässig, manuelle Benutzung wird
            empfohlen!
          </b>
        </p>
        <MarkdownTester
          content={`# Table of contents
# Überschrift 1
## Überschrift 2
## Überschrift 2
### Überschrift 3
### Überschrift 3
## Überschrift 2`}
        />

        <AncoredTitle subtitle>HTML / XSS</AncoredTitle>
        <p>
          Campboard behandelt Markdown und löscht potenziell unerwünschte
          Inhalte.
        </p>
        <MarkdownTester
          content={`<script>alert('XSS works!');</script>

<div data-hover="hello mouse">
    test
</div>

<b>jhgrejig</b>

<p>rjiufgigjr</p>`}
        />
      </Col>
    </Row>
  );
}

export function AncoredTitle(props) {
  if (typeof props.children !== "string") {
    return <h2>{props.children}</h2>;
  }

  const value = props.children.toString();
  const normalizedValue = value.replaceAll(" ", "_").toLowerCase();

  if (props.subtitle) {
    return (
      <h4 className="mb-2 mt-4" id={normalizedValue}>
        {props.children}
        <a className="anchor" href={`#${normalizedValue}`}>
          .
        </a>
      </h4>
    );
  }

  return (
    <h3 id={normalizedValue}>
      {props.children}
      <a className="anchor" href={`#${normalizedValue}`}>
        .
      </a>
    </h3>
  );
}
